import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tm1ToastContainer } from '@tm1/design-system-react';
import { createContext, useContext, useRef } from 'react';
export const ToastContainerContext = createContext(undefined);
export const useToastContainerContext = () => useContext(ToastContainerContext);
export const ToastContainerProvider = ({ children }) => {
    const toastContainerRef = useRef(null);
    return (_jsxs(ToastContainerContext.Provider, { value: toastContainerRef, children: [children, _jsx(Tm1ToastContainer, { ref: toastContainerRef })] }));
};
